import { render, staticRenderFns } from "./UserRequestsEdit.vue?vue&type=template&id=66d9201e&"
import script from "./UserRequestsEdit.vue?vue&type=script&lang=js&"
export * from "./UserRequestsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports